import styled from 'styled-components'

export const TableContainer = styled('div')`
  max-height: 455px;
  overflow: auto;
`

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 32px 32px;
`
